import { WidgetWithTablePieDataType } from '@/types';

const colorsPalette = {
  yellow: ['#F9A31D', '#EBEEF2'],
  green: ['#6CB073', '#EBEEF2'],
  red: ['#ED5050', '#EBEEF2'],
};

export const prepareBigWidgetChartOptions = (
  value: number,
  pieData: WidgetWithTablePieDataType[],
  color: keyof typeof colorsPalette,
) => ({
  fontFamily: 'Open Sans',
  tooltip: {
    trigger: 'item',
    backgroundColor: '#282828',
    borderColor: '#282828',
    textStyle: {
      color: '#FFFFFF',
    },
    padding: 16,
    formatter(params: any) {
      const itemName = params.data.name;
      const colorSpan = (color: any) =>
        `<span style="display: inline-block; margin-right: 5px; border: 1px solid #fff; border-radius: 10px; width: 9px; height: 9px; background-color: ${color}"></span>`;
      return `<p style="padding: 0; margin: 0">${colorSpan(params.color)}${itemName}: ${params.data.value.toFixed(2)}%</p>`;
    },
  },
  label: {
    fontSize: 28,
    fontFamily: 'Open Sans',
    fontWeight: 600,
    fontStyle: 'normal',
    color: colorsPalette[color][0],
    formatter: `${value.toFixed(2)}%`,
  },
  color: colorsPalette[color],
  series: [
    {
      type: 'pie',
      radius: ['60%', '73%'],
      avoidLabelOverlap: false,
      legendHoverLink: false,
      center: ['40%', '50%'],
      labelLayout: {
        hideOverlap: true,
      },
      label: {
        normal: {
          width: '96',
          border: 100,
          show: true,
          position: 'center',
          formatter: `${value.toFixed(2)}%`,
          rich: {
            a: {
              fontFamily: 'Open Sans',
              fontWeight: 600,
              fontStyle: 'normal',
              fontSize: '12px',
              color: '#f35461',
            },
          },
        },
        emphasis: {
          focus: 'series',
          blurScope: 'coordinateSystem',
          width: '96',
          backgroundColor: 'rgba(255, 255, 255, 1)',
          show: true,
          formatter: (params: { value: number }) => `${params.value.toFixed(2)}%`,
          rich: {
            a: {
              fontFamily: 'Open Sans',
              fontWeight: 600,
              fontStyle: 'normal',
              fontSize: '12px',
              color: '#7BD5A7',
            },
          },
        },
      },
      itemStyle: {
        normal: {
          label: {
            show: false,
          },
        },
        emphasis: {
          label: {
            show: true,
          },
        },
      },
      emphasis: {
        label: {
          show: false,
          fontSize: '10',
          fontWeight: 'bold',
        },
      },
      labelLine: {
        show: false,
      },
      data: pieData,
    },
  ],
});
